import Navbar from "./components/Navbar/Navbar";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Profile } from "./pages/Profile";
import Home from "./pages/Home";
import CarWash from "./pages/CarWash";
import Service from "./pages/Service";
import Products from "./pages/Products";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import { Footer } from "./components/Footer/Footer";

export const UserApp = () => {
  return (
    <div className="flex flex-col min-h-screen custom-scroll">
      <Navbar />

      <Toaster
        position="top-right"
        containerClassName="mt-10"
        toastOptions={{
          className:
            "bg-popupLight dark:bg-popupDark dark:text-primaryTextDark text-primaryText rounded-md shadow-lg p-4 font-medium",
          duration: 3000,
          success: {
            className:
              "bg-popupLight dark:bg-popupDark text-green-800 dark:text-green-200",
          },
          error: {
            className:
              "bg-popupLight dark:bg-popupDark text-red-800 dark:text-red-200",
          },
        }}
      />

      <main className="flex-grow bg-primaryBg dark:bg-primaryBgDark">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/wash" element={<CarWash />} />
          <Route path="/service" element={<Service />} />
          <Route path="/products" element={<Products />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </main>

      <Login />
      <SignUp />
      <Footer />
    </div>
  );
};
